import { request } from "apis/base";
import {
  MeasurementUnitRequest,
  MeasurementUnitUpdate,
} from "constants/types/measurement";
import { CommonParamsType } from "constants/types/common";

export const measurementUnitApi = {
  getAll: (params?: CommonParamsType) => {
    return request({ url: "/measurement-unit", method: "GET", params });
  },

  create: (data: MeasurementUnitRequest) => {
    return request({ url: "/measurement-unit", method: "POST", data });
  },

  update: (id: string, data: MeasurementUnitUpdate) => {
    return request({ url: `/measurement-unit/${id}`, method: "PUT", data });
  },

  delete: (id: string) => {
    return request({ url: `/measurement-unit/${id}`, method: "DELETE" });
  },
};
